import React from 'react';

import { PLAYER_ICON_DEFAULT } from '../../../common/staticData';
import { getFieldName } from './fieldMapping';
import '../coach_style.css';

const LeadersPlayerStatItem = ({ player, option, isTotal, onShow }) => {

    // Helper function to safely format numbers and handle NaN
    const safeParseFloat = (value, defaultValue = 0) => {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? defaultValue : parsed;
    };

    // Helper function to calculate average: total / games played
    const calcAverage = (player, option) => {
        const gamesPlayed = safeParseFloat(player.total_player_games);
        if (gamesPlayed === 0) return '0';

        // Get the total field name
        const totalFieldName = getFieldName(option, true);
        const totalValue = safeParseFloat(player[totalFieldName]);

        const average = totalValue / gamesPlayed;
        return average.toFixed(1);
    };

    // Helper function to calculate sum of averages for saved + super_save
    const calcSavedAverage = (player) => {
        const gamesPlayed = safeParseFloat(player.total_player_games);
        if (gamesPlayed === 0) return '0';

        const totalSaved = safeParseFloat(player[getFieldName('saved', true)]);
        const totalSuperSave = safeParseFloat(player['total_super_save']);

        const average = (totalSaved + totalSuperSave) / gamesPlayed;
        return average.toFixed(1);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', minHeight: '100px', padding: '8px', justifyContent: 'space-between', cursor: 'pointer' }} onClick={() => onShow(player)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ width: '88px', height: '88px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img  
                    src={ player.player_image ? (player.player_image.includes(process.env.REACT_APP_S3_URI)
                    ? player.player_image : process.env.REACT_APP_S3_URI + player.player_image)
                    : PLAYER_ICON_DEFAULT } style={{ height: '100%', borderRadius: '8px' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: '2px' }}>
                    <p className="normal-text">{player.player_full_name}</p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {player.player_jersey_number < 999 && <p className="normal-text">{`#${player.player_jersey_number}`}</p>}
                        <p className="normal-text">{player.player_position_name}</p>
                    </div>
                    <p className="normal-text">{player.team_name}</p>
                    <p className="normal-text">
                        {player.total_player_games === 0 ? 'No games played' : player.total_player_games === 1 ? '1 game played' : player.total_player_games + ' games played'}
                    </p>
                </div>
            </div>
            <p className="bigger-text">
                {isTotal
                    ? option === 'saved'
                        ? safeParseFloat(player[getFieldName(option, true)]) + safeParseFloat(player['total_super_save'])
                        : safeParseFloat(player[getFieldName(option, true)])
                    : option === 'saved'
                    ? calcSavedAverage(player)
                    : calcAverage(player, option)}
            </p>
        </div>
    );
};

export default LeadersPlayerStatItem;
